export const state = {
    utils: {},
};

export const getters = {
    utils: (state) => state.utils,
};

export const mutations = {
    setUtils(state, data) {
        state.utils[data.key]=data.val;
    },
};

export const actions = {
    setUtils({commit}, data) {
        commit("setUtils",data);
    },
};
